import { Grid, Typography } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import { TestimonialsContent } from 'src/types/components/shared/atom'
import PartialSlider from '../partialSlider/PartialSlider'
import useStyles from './Style'

interface IProps {
  content: TestimonialsContent
  zenMode: boolean
}
const NotAlone: React.FC<IProps> = ({ content, zenMode }) => {
  const { heading, text } = content
  const { classes } = useStyles()
  return (
    <Grid
      container
      className={clsx(
        classes.rootContainer,
        zenMode && classes.rootZenContainer
      )}
    >
      <Grid item md={8} sm={12} className={classes.textContainer}>
        <Typography className={classes.heading}>{heading}</Typography>
        <Typography className={classes.text}>{text}</Typography>
      </Grid>

      <Grid item md={12} sm={12} xs={12} sx={{ margin: 'auto' }}>
        <PartialSlider zenMode={zenMode} content={content.cardData} />
      </Grid>
    </Grid>
  )
}

export default NotAlone
